export const VIRTUAL_ASSISTANT_API_CONFIG = {
  provider: 'groq',
  backendBaseUrl: '', // Not used anymore for direct Groq calls
  assistantEndpoint: '', // Not used anymore
  turnModel: 'openai/gpt-oss-120b',
  diagnosisModel: 'openai/gpt-oss-120b',
  fallbackModels: [
    'openai/gpt-oss-120b',
  ],
  providerRetryCooldownMs: 8000,
};

export default VIRTUAL_ASSISTANT_API_CONFIG;
